import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_soft_taro.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganSoftTaroBun() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Soft Taro Bun",
    content_category: "Vegan Menu",
    content_ids: ["vegan_soft_taro_bun"],
    content_type: "vegan_vietnamese_pastries",
    value: 4.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Soft Taro Bun | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Soft, delicately layered dough filled with smooth taro paste that's gently sweet and comforting. Each bite melts easily, letting the natural, earthy flavor come through."
        />
        <meta
          property="og:title"
          content="Vegan Soft Taro Bun | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Soft, delicately layered dough filled with smooth taro paste that's gently sweet and comforting. Each bite melts easily, letting the natural, earthy flavor come through."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN SOFT TARO BUN"
          titleSubHead="$4.00 each"
          detailBody="A taste of nature's vanilla. Soft, delicately layered dough filled with smooth taro paste that's gently sweet and comforting. Each bite melts easily, letting the natural, earthy flavor come through."
          detailBodyBr="Contains: wheat"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganSoftTaroBun;